import {Injectable} from '@angular/core';
import {BaseEndpoint} from "../../../../base/endpoints/base.endpoint";
import {environment} from "../../../../../environments/environment";
import {IParams} from "../../../../base/endpoints/iparams";

@Injectable({
  providedIn: 'root'
})
export class CmsEndpoint extends BaseEndpoint {

  constructor() {
    super();
  }

  static FILES = {
    FILE_ENDPOINT: environment.file_service_url + BaseEndpoint.API_VERSION_3 + '/files',
    IMAGE_ENDPOINT: environment.file_service_url + BaseEndpoint.API_VERSION_3 + '/files/images',
    IMAGE_ENDPOINT_ADMIN: environment.file_service_url + BaseEndpoint.API_VERSION_3 + '/admin/files/images',
    IMAGE_UPLOAD_ENDPOINT_BULK: environment.file_service_url + BaseEndpoint.API_VERSION_3 + '/files/images/bulk',
    FILE_ENDPOINT_ADMIN: environment.file_service_url + BaseEndpoint.API_VERSION_2 + '/admin/files',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(): string {
      return this.FILE_ENDPOINT
    },
    UPLOAD(params: IParams): string {
      return this.IMAGE_UPLOAD_ENDPOINT_BULK.concat(BaseEndpoint.toParamString(params));
    },
    GET(id: number): string {
      return this.FILE_ENDPOINT + '/' + id
    },
    UPDATE(id: number): string {
      return this.FILE_ENDPOINT + '/' + id
    },
  }

}
